import { makeStyles } from "@material-ui/core/styles";
import { Button, Backdrop, CircularProgress } from "@material-ui/core";
import { useEffect, useState, useContext } from "react";
import { AppContext } from "../AppContext";
import LineChart from "../components/LineChart";
import MunicipioDialog from "../components/MunicipioDialog";

const useStyles = makeStyles((theme) => ({
  btnContainer: {
    alignSelf: "center",
    marginTop: "10px",
    width: "100%",
    maxWidth: "760px",
    display: "flex",
    justifyContent: "space-evenly",
    minHeight: "max-content",
  },
  selected: {
    fontSize: "2rem",
    fontWeight: "200",
    margin: "25px 0px",
  },
  high: {
    zIndex: 2000,
  },
}));

const Graficas = () => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState("Estatal");
  const { graphs, setGraphs } = useContext(AppContext);

  useEffect(() => {
    const fetchGraphs = async () => {
      if (graphs) return;

      const res = await fetch(
        "https://api-sinaloa-covid-app.netlify.app/graphs.json"
      );
      let data = await res.json();
      setGraphs(data);
      console.log(data);
    };
    fetchGraphs();
  }, [graphs, setGraphs]);

  if (!graphs) {
    return (
      <Backdrop open={true} className={classes.high}>
        <CircularProgress color="primary" className={classes.high} />
      </Backdrop>
    );
  }

  return (
    <>
      <div className={classes.btnContainer}>
        <Button
          variant="contained"
          color="primary"
          size="large"
          onClick={() => setSelected("Estatal")}
        >
          Estatal
        </Button>
        <Button
          variant="contained"
          color="primary"
          size="large"
          onClick={() => setOpen(true)}
        >
          Municipio
        </Button>
      </div>
      <p className={classes.selected}>{selected}</p>
      <MunicipioDialog
        open={open}
        setOpen={setOpen}
        setSelected={setSelected}
        data={graphs.names}
      />
      <LineChart
        title="Casos 90 días"
        data={graphs[selected].newCases}
        max={graphs[selected].maxNewCases.date}
      />
      <LineChart
        title="Muertes 90 días"
        data={graphs[selected].newDeaths}
        max={graphs[selected].maxNewDeaths.date}
      />
    </>
  );
};

export default Graficas;
